module.exports = __webpack_public_path__ + "img/r3_cangqiongzhiyi.b06887e9.jpg";